<table class="table table-borderless table-sm table-hover">
  <thead>
    <tr>
      <th scope="col">Site Name</th>
      <th scope="col">Type</th>
      <th scope="col">Source Catalog</th>
    </tr>
  </thead>
  <tbody>
    @for (d of model.slice(); track d['POSDT ID']) {
    <tr>
      <td>
	<a [routerLink]="['/sites', d['POSDT ID']]">
	  {{d['Site Name'] || d['POSDT ID']}}</a>
      </td>
      <td>{{(d['Site Type'] || []).join(', ')}}</td>
      <td>{{abbreviate(d['Source Catalog'])}}</td>
    </tr> }
  </tbody>
</table>

<nav aria-label="Page navigation" class="row">
  <ul class="pagination ms-auto col-auto">
    @if (model.page() > 2) {
    <li class="page-item">
      <a class="page-link"
	 [queryParams]="model.setPage(1)"
	 [routerLink]="[]">&laquo;</a>
    </li> }
    @if (model.page() > 1) {
    <li class="page-item">
      <a class="page-link"
	 [queryParams]="model.setPage(model.page() - 1)"
	 [routerLink]="[]">&lsaquo;</a>
    </li> }
    @if (model.page() > 2) {
    <li class="page-item">
      <a class="page-link"
	 [queryParams]="model.setPage(model.page() - 2)"
	 [routerLink]="[]">{{model.page() - 2}}</a>
    </li> }
    @if (model.page() > 1) {
    <li class="page-item">
      <a class="page-link"
	 [queryParams]="model.setPage(model.page() - 1)"
	 [routerLink]="[]">{{model.page() - 1}}</a>
    </li> }
    <li class="page-item active">
      <a class="page-link"
	 [queryParams]="model.setPage(model.page())"
	 [routerLink]="[]">{{model.page()}}</a>
    </li>
    @if (model.page() < numPages()) {
    <li class="page-item">
      <a class="page-link"
	 [queryParams]="model.setPage(model.page() + 1)"
	 [routerLink]="[]">{{model.page() + 1}}</a>
    </li> }
    @if (model.page() < numPages() - 1) {
    <li class="page-item">
      <a class="page-link"
	 [queryParams]="model.setPage(model.page() + 2)"
	 [routerLink]="[]">{{model.page() + 2}}</a>
    </li> }
    @if (model.page() < numPages()) {
    <li class="page-item">
      <a class="page-link"
	 [queryParams]="model.setPage(model.page() + 1)"
	 [routerLink]="[]">&rsaquo;</a>
    </li> }
    @if (model.page() < numPages() - 1) {
    <li class="page-item">
      <a class="page-link"
         [queryParams]="model.setPage(numPages())"
	 [routerLink]="[]">&raquo;</a>
    </li> }
  </ul>
  <div class="dropdown col-auto">
    <button class="btn btn-outline-success dropdown-toggle"
	    type="button"
	    data-bs-toggle="dropdown" aria-expanded="false">Show
      {{model.limit()}}</button>
    <ul class="dropdown-menu">
      @for (n of [10, 25, 50, 100]; track n) {
      <li><a class="dropdown-item"
	     [queryParams]="model.setLimit(n)"
	     [routerLink]="[]">{{n}}</a></li> }
    </ul>
  </div>
</nav>
